import type { QBoxStylesManager } from "../CoreApp/QBoxStylesManager";
import type { QChartBox } from "../CoreApp/QChartBox";
import type { QChartTemplate } from "../CoreApp/QChartTemplate";
import { QChartTemplateProcessor } from "../CoreApp/QChartTemplateProcessor";
import type { QXDoc } from "../CoreApp/QXDoc";
import type { QXWSMgr } from "../CoreApp/QXWSMgr";

export function ApplyChartTemplateToBoxes(
  targetDoc: QXDoc,
  template: QChartTemplate,
  boxList: null | QChartBox[],
  applyToSubChart: false | number,
  wsMgr: QXWSMgr,
  boxStyleMgr: QBoxStylesManager
) {
  const processor = new QChartTemplateProcessor(
    targetDoc,
    template,
    boxList,
    applyToSubChart,
    wsMgr,
    boxStyleMgr
  );

  return processor.Apply();
}
